export default __webpack_public_path__ + "static/media/logo_lublinsas.4f48f719.png";